import { useSelector, TypedUseSelectorHook } from 'react-redux';
import type { ReduxState } from '../store';

export const useTypedSelector: TypedUseSelectorHook<ReduxState> = useSelector;
